export enum ImportType {
  HistoricalData = "historicaldata",
}
